var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCultureHeart = function SvgIconCultureHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.907 3.06c-1.482-1.414-3.882-1.414-5.364 0l-5.9 5.62 4.296 4.094a1.539 1.539 0 0 0 2.11 0l4.84-4.615a3.48 3.48 0 0 0 0-5.098h.018Z",
    fill: "#34C759"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.068 12.784 4.305-4.104-5.9-5.62c-1.481-1.414-3.873-1.414-5.355 0-1.49 1.415-1.49 3.704 0 5.109l4.83 4.605a1.532 1.532 0 0 0 2.12 0v.01Z",
    fill: "#34C759"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2.644 8.68 4.295 4.094a1.558 1.558 0 0 0 2.11 0l4.305-4.103-5.346-5.099L2.644 8.68Z",
    fill: "url(#icon-culture-heart_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-culture-heart_svg__a",
    x1: -2.47,
    y1: 8.147,
    x2: 21.739,
    y2: 8.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#00A600"
  })))));
};
export default SvgIconCultureHeart;